
import Navbar from '../Components/Navbar'
import Footer from '../Components/Footer'
import React, { useEffect } from 'react';
import $ from 'jquery';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import 'slick-carousel';
import Swiper from 'swiper';
import 'swiper/swiper-bundle.css';
import AOS from 'aos';
import 'aos/dist/aos.css';
import { Link,useNavigate } from "react-router-dom";
import PureCounter from "@srexi/purecounterjs";
import ConatctForm from '../Components/ContactForm';
const Service = () => {
  useEffect(() => {
    // Initialize AOS (Animate On Scroll)
    AOS.init();

    // Initialize Swiper
    const swiper = new Swiper('.review-swiper', {
      spaceBetween: 15,
      pagination: {
        el: '.swiper-pagination',
        clickable: true,
      },
      breakpoints: {
        320: { slidesPerView: 3 },
        480: { slidesPerView: 1 },
        768: { slidesPerView: 3 },
        1024: { slidesPerView: 4 },
      },
    });

    // Initialize PureCounter
    new PureCounter({
      selector: '.purecounter',
      start: 0,
      end: 500,
      duration: 1,
      delay: 10,
      once: true,
      pulse: false,
      decimals: 0,
      legacy: true,
      filesizing: false,
      currency: false,
      formater: 'us-US',
      separator: false,
    });

    // Handle Scroll Event for Navbar Shadow
    const handleScroll = () => {
      const navbar = document.querySelector('.navbar');
      if (window.scrollY > 50) {
        navbar.classList.add('shadow');
      } else {
        navbar.classList.remove('shadow');
      }
    };

    window.addEventListener('scroll', handleScroll);

    // Cleanup event listener on unmount
    return () => {
      window.removeEventListener('scroll', handleScroll);
      swiper.destroy();
    };
  }, []);

  return (
    <div>
   <Navbar/>
   <div class="container servicesContent">
        <section id="servicessection">
            <div class="container" data-aos="fade-up">
      
              <header >
                <h3 class="section-header">Our Services</h3>
                <p>We augment client teams with their software development, testing, maintenance and support. Our primary focus is Business Automation and SOA system integration, leveraging Java, PHP, dotNet and Web 2.0 related technologies. We deliver these services as turnkey projects or through our extended team model (mODC - managed Offshore Development Center), providing a completely managed team, to ensure continuity and efficiency.</p>
              </header>
      
              <div class="row text-center mt-4 service-box-container">
                {/* <!-- mODC --> */}
                <div class="col-md-6 service-box d-flex align-items-center flex-row-reverse">
                    <div class="hexagon">
                        <i class="fas fa-building"></i>
                    </div>
                    <div class="service-box-content">
                        <h4>mODC</h4>
                        <p>Managed Offshore Development Center model, provides a managed team of developers, as an extension of client teams.</p>
                    </div>
                </div>
        
                {/* <!-- Turnkey Solutions --> */}
                <div class="col-md-6 service-box d-flex align-items-center flex-row">
                    <div class="hexagon">
                        <i class="fas fa-lightbulb"></i>
                    </div>
                    <div class="service-box-content">
                        <h4>Turnkey Solutions</h4>
                        <p>Providing end-to-end IT system integration solutions tailored to customers' custom requirements.</p>
                    </div>
                </div>
        
                {/* <!-- Third Party QA --> */}
                <div class="col-md-6 service-box d-flex align-items-center flex-row-reverse">
                    <div class="hexagon">
                        <i class="fas fa-search"></i>
                    </div>
                    <div class="service-box-content">
                        <h4>Third Party QA</h4>
                        <p>Dedicated team ensuring objective testing of software systems for faster, more confident launches.</p>
                    </div>
                    
                </div>
        
                {/* <!-- Mobile Development --> */}
                <div class="col-md-6 service-box d-flex align-items-center flex-row">
                    <div class="hexagon-container">
                        <div class="hexagon">
                            <i class="fas fa-building"></i>
                        </div>
                    </div>
                    <div class="service-box-content">
                        <h4>Mobile Development</h4>
                        <p>Keeping pace with mobile technologies, we develop enterprise-grade cross-platform applications.</p>
                    </div>
                </div>
        
                {/* <!-- DevOps Consulting Services --> */}
                <div class="col-md-12 service-box">
                    <div class="hexagon">
                        <i class="fas fa-sync-alt"></i>
                    </div>
                    <div class="service-box-content">
                        <h4>DevOps Consulting Services</h4>
                        <p>Helping you build a DevOps environment from scratch and redefine your delivery and deployment strategy.</p>
                    </div>
                </div>
            </div>
            </div>
          </section>
         <ConatctForm/>
      </div>
      <Footer/>

    </div>

    
  )
}

export default Service